import {
  GAME_ID,
  REDUX_ACTIONS,
  ANSWER_TYPES,
} from '../../data/constants';

const initialState = {
  // props synced with curriculum data
  uuid: null,
  questionId: null,
  targetText: '',
  keywords: [],
  storyId: null,
  quadrants: [],
  // custom props
  correctAnswer: null,
  isAnswerCorrect: null,
  userAnswer: null,
  attemptsCount: 0,
};

const questionReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_QUESTION: {
      const {
        uuid,
        questionId,
        targetText,
        rwTaggedText,
        keywords,
        isMatch,
        storyId,
        quadrants,
      } = action.payload.question;

      return {
        ...initialState,
        uuid,
        questionId,
        targetText,
        rwTaggedText,
        keywords,
        storyId,
        quadrants,
        correctAnswer: isMatch ? ANSWER_TYPES.AGREE : ANSWER_TYPES.DISAGREE,
      };
    }
    case REDUX_ACTIONS.SERVE_ANSWER: {
      const { isAnswerCorrect, userAnswer } = action.payload;

      return {
        ...state,
        isAnswerCorrect,
        attemptsCount: state.attemptsCount + 1,
        userAnswer,
      };
    }
    default:
      return state;
  }
};

export default questionReducer;
